export default "__VITE_ASSET__Dbgj0qwL__"